/*=========================================================================================
File Name: store.js
Description: Vuex store
----------------------------------------------------------------------------------------
Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
Author: Pixinvent
Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/

import Vue from 'vue'
import Vuex from 'vuex'
// import createPersistedState from "vuex-persistedstate" // NOTE: Replaced Localstorage persisted state with IndexedDB
import createPersistedState from "vuex-persist-indexeddb"

import state from "./state"
import getters from "./getters"
import mutations from "./mutations"
import actions from "./actions"

Vue.use(Vuex)

import moduleAuth from './auth/moduleAuth.js'

export default new Vuex.Store({
    getters,
    mutations,
    state,
    actions,
    modules: {
        auth: moduleAuth,
    },
    plugins: [
        createPersistedState({
            // Exclude runtime override flag so build-time env can control it
            reducer: (state) => {
                const s = Object.assign({}, state)
                delete s.disableCNICFlag
                return s
            }
        })
    ],
    strict: process.env.NODE_ENV !== 'production'
})